import { columns } from './properties/columns'
import { columnsForPatients } from './properties/columnsForPatients'
import { filter } from './properties/filter'
import { sort } from './../properties/sort'
import { pagination } from './../properties/pagination'
import { model } from "./properties/model";
import { rules } from "./properties/rules";

export const state = {
    list: [],
    patient_list: [],
    informal_patient_list: [],
    prices: [],
    model: JSON.parse(JSON.stringify(model)),
    relation_model: [],
    columns: columns,
    columnsNew: columnsForPatients,
    filter: filter,
    pagination: JSON.parse(JSON.stringify(pagination)),
    sort: JSON.parse(JSON.stringify(sort)),
    rules: rules
};